<template>
  <el-container style="display: block;background: #fdfdfd;">
    <Header/>
    <el-container>
      <Aside/>
      <el-container>
        <el-main>
          <router-view/>
        </el-main>
        <el-footer>
          <a class="footers" target="_blank" href="http://www.996w.com">技术支持：九六网</a>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
  
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Header from '@/components/layout/Header.vue';
import Aside from '@/components/layout/Aside.vue';

export default defineComponent({
  name: 'Home',
  components: {
    Header,
    Aside,
  },
});
</script>
<style scoped>
.el-footer{
  padding:10px;
  height: 40px;
  text-align: center;
}
.el-footer a{
  color: #666666;
}

</style>